export var AutoCompleteAddress = function(place) {
    var googleAutocompleteResult = {};
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        sublocality_level_1: 'long_name',
        postal_town: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name',
        postal_code_suffix: 'short_name'
    };
    // Constructor
    if (place && place.address_components) {
        for (var index = 0; index < place.address_components.length; index++) {
            var addressType = place.address_components[index].types[0];
            if (addressType) {
                var addressValue = place.address_components[index][componentForm[addressType]];
                switch (addressType) {
                case 'street_number':
                    googleAutocompleteResult.streetNumber = addressValue;
                    break;
                case 'route':
                    googleAutocompleteResult.route = addressValue;
                    break;
                case 'locality':
                    googleAutocompleteResult.locality = addressValue;
                    break;
                case 'postal_town':
                    googleAutocompleteResult.postalTown = addressValue;
                    break;
                case 'sublocality_level_1':
                    googleAutocompleteResult.sublocality = addressValue;
                    break;
                case 'administrative_area_level_1':
                    googleAutocompleteResult.adminArea = addressValue;
                    break;
                case 'country':
                    googleAutocompleteResult.country = addressValue;
                    break;
                case 'postal_code':
                    googleAutocompleteResult.postalCode = addressValue;
                    break;
                case 'postal_code_suffix':
                    googleAutocompleteResult.postalCodeSuffix = addressValue;
                    break;
                default: {
                    break;
                }
                }
            }
        }
        if (googleAutocompleteResult.postalCode && googleAutocompleteResult.postalCodeSuffix) {
            googleAutocompleteResult.postalCode = googleAutocompleteResult.postalCode
                + '-' + googleAutocompleteResult.postalCodeSuffix;
        }
    }
    return googleAutocompleteResult;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/autocompleteAddress.js
// module id = 47
// module chunks = 0